import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettRxsSeries } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';


const MxSettRxSeriesForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  const r_snack_record_used = React.useRef(null);

  let r_form = React.useRef(null);

  const [storeSettRxsSeries, setStoreSettRxsSeries] = useSessionStorage('StoreSettRxsSeries', StoreSettRxsSeries);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }

  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettRxsSeries.itSeriesRx = lastSaveRv.theValue;
      Promise.all([setStoreSettRxsSeries(storeSettRxsSeries)]).then((result) => {
        navBack();
      });
    }
  }

  const formDelete = async (rv) => {
    if (rv.theValue==='rv_is_referenced') {
      r_snack_record_used.current.setOpen(true);
    }
  }

  return (
    <div>
      <GxForm 
        moduleName={trans('field.series')}
        xref={r_form}
        url="sett/series_rx" 
        filterIdField='itSeriesRx'
        filterIdValue={storeSettRxsSeries.itSeriesRx} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_series_rx.itSeriesRx" value={storeSettRxsSeries.itSeriesRx || ''} />
        <CxInput xref={useRef(null)} label={trans('field.series')} dbfield="t_series_rx.txTypeSeriesRx" required />
        <CxInput xref={useRef(null)} label={trans('field.notes')} dbfield="t_series_rx.txNotes" minRows={8} maxLength={100} />
        
      </GxForm>

      <CxSnackbar xref={r_snack_record_used} severity="error" value={trans('msg.record_used')} />

    </div>
  );

}

export default MxSettRxSeriesForm;
